export default "__VITE_ASSET__J2Kk5iIH__"